var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_635_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5686 0.0216667C14.9877 0 16.3961 0.0108333 17.8044 0C17.8911 1.6575 18.4869 3.3475 19.7002 4.5175C20.9136 5.72 22.6252 6.2725 24.2936 6.45667V10.8225C22.7336 10.7683 21.1627 10.4433 19.7436 9.77167C19.1261 9.49 18.5519 9.1325 17.9886 8.76417C17.9777 11.9275 17.9994 15.0908 17.9669 18.2433C17.8802 19.76 17.3819 21.2658 16.5044 22.5117C15.0852 24.5917 12.6261 25.9458 10.1019 25.9892C8.55272 26.0758 7.00355 25.6533 5.68189 24.8733C3.49355 23.5842 1.95522 21.2225 1.72772 18.6875C1.70605 18.1458 1.69522 17.6042 1.71689 17.0733C1.91189 15.015 2.93022 13.0433 4.51189 11.7C6.31022 10.14 8.82355 9.3925 11.1744 9.83667C11.1961 11.44 11.1311 13.0433 11.1311 14.6467C10.0586 14.3 8.80189 14.3975 7.85939 15.0475C7.17689 15.4917 6.65689 16.1742 6.38606 16.9433C6.15856 17.4958 6.22356 18.1025 6.23439 18.6875C6.49439 20.4642 8.20606 21.9592 10.0261 21.7967C11.2394 21.7858 12.3986 21.0817 13.0269 20.0525C13.2327 19.695 13.4602 19.3267 13.4711 18.9042C13.5794 16.965 13.5361 15.0367 13.5469 13.0975C13.5577 8.73167 13.5361 4.37667 13.5686 0.0216667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_635_509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.a552e3645d9994bf813a422861362235.svg";
export { ForwardRef as ReactComponent };